import { FaWallet, FaArrowUp, FaArrowDown, FaReceipt } from 'react-icons/fa'
import { useMyTransactions, useWalletBalance } from '@/hooks/useProviderWallet'
import { useNavigate } from 'react-router-dom'
import routes from '@/routes/routes'
import Button from '@/components/common/Button/Button'
import './ProviderWallet.css'

const ProviderWallet = () => {
    const { data: balance, isLoading: balLoading, isError: balError } = useWalletBalance()
    const { data: txs, isLoading, isError } = useMyTransactions()
    const navigate = useNavigate()

    // Safely extract transactions array from API response
    const transactions = Array.isArray(txs) ? txs : (txs?.results || txs?.transactions || [])

    return (
        <div className="provider-wallet-page">
            {/* Header */}
            <div className="provider-wallet-header">
                <div className="provider-wallet-header-content">
                    <h1 className="provider-wallet-title">Mi Billetera</h1>
                    <p className="provider-wallet-subtitle">Gestiona tus ingresos y retiros</p>
                </div>
            </div>
            
            <div className="provider-wallet-container">

                {/* Balance Card */}
                {balLoading ? (
                    <div className="provider-wallet-message">
                        <p>Cargando balance...</p>
                    </div>
                ) : balError ? (
                    <div className="provider-wallet-message">
                        <p>Error al cargar balance</p>
                    </div>
                ) : (
                    <div className="provider-wallet-balance">
                        <div className="provider-wallet-balance-icon">
                            <FaWallet />
                        </div>
                        <h2 className="provider-wallet-balance-label">Balance Disponible</h2>
                        <div className="provider-wallet-balance-amount">
                            S/ {Number(balance?.available_balance || 0).toFixed(2)}
                        </div>
                        
                        <div className="provider-wallet-stats">
                            <div className="provider-wallet-stat">
                                <span className="provider-wallet-stat-label">En proceso</span>
                                <span className="provider-wallet-stat-value">S/ {Number(balance?.pending_balance || 0).toFixed(2)}</span>
                            </div>
                            <div className="provider-wallet-stat">
                                <span className="provider-wallet-stat-label">Total retirado</span>
                                <span className="provider-wallet-stat-value">S/ {Number(balance?.total_withdrawn || 0).toFixed(2)}</span>
                            </div>
                        </div>
                        
                        <Button
                            variant="primary"
                            size="lg"
                            disabled={!balance || balance.available_balance <= 0}
                            onClick={() => navigate(routes.providerWithdrawal)}
                        >
                            <FaArrowUp />
                            Solicitar Retiro
                        </Button>
                    </div>
                )}

                {/* Transactions History */}
                <div className="provider-wallet-transactions">
                    <h3 className="provider-wallet-transactions-title">Historial de Transacciones</h3>
                    
                    {isLoading ? (
                        <div className="provider-wallet-message">
                            <p>Cargando transacciones...</p>
                        </div>
                    ) : isError ? (
                        <div className="provider-wallet-message">
                            <p>Error al cargar transacciones</p>
                        </div>
                    ) : transactions.length === 0 ? (
                        <div className="provider-wallet-empty">
                            <FaReceipt className="provider-wallet-empty-icon" />
                            <p>No hay transacciones aún</p>
                        </div>
                    ) : (
                        <div className="provider-wallet-transaction-list">
                            {transactions.map((t: any) => (
                                <div key={t.id} className="provider-wallet-transaction">
                                    <div className="provider-wallet-transaction-icon" style={{
                                        background: t.transaction_type === 'service_payment' ? 'var(--success-100)' : 'var(--error-100)'
                                    }}>
                                        {t.transaction_type === 'service_payment' ? <FaArrowDown style={{color: 'var(--success-600)'}} /> : <FaArrowUp style={{color: 'var(--error-600)'}} />}
                                    </div>
                                    <div className="provider-wallet-transaction-info">
                                        <div className="provider-wallet-transaction-desc">{t.description}</div>
                                        <div className="provider-wallet-transaction-date">
                                            {new Date(t.created).toLocaleDateString('es-ES')}
                                        </div>
                                    </div>
                                    <div className="provider-wallet-transaction-amounts">
                                        <div className="provider-wallet-transaction-amount" style={{
                                            color: t.transaction_type === 'withdrawal' ? 'var(--error-500)' : 'var(--success-500)'
                                        }}>
                                            {t.transaction_type === 'withdrawal' ? '-' : '+'}S/ {Math.abs(t.amount).toFixed(2)}
                                        </div>
                                        <div className="provider-wallet-transaction-balance">
                                            Balance: S/ {Number(t.balance_after).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}                </div>
            </div>
        </div>
    )
}

export default ProviderWallet


